<template>
  <section class="bg-white header">
    <div class="menu-header">
      <div class="header-top">
        <div class="header-left">
          <!-- <Tag type="primary"
               outline
               size="small"
               class="mr-2 menu-header-tag"
               v-if="categoryTag">
            {{ categoryTag }}
          </Tag> -->
          <div class="menu-id" v-if="menuBasicInfo && menuBasicInfo.menuNo">
            メニューNo. {{ menuBasicInfo.menuNo }}
          </div>
        </div>
        <div class="header-right">
          <Share :key="router"/>
        </div>
      </div>
      <h2 class="menu-title" v-if="menuBasicInfo && menuBasicInfo.menuNm">
        <a-tooltip>
          <template slot="title">
           <span v-html="menuBasicInfo.menuNm.replaceAll('\n', '<br>')"> </span>
          </template>
          <span v-html="menuBasicInfo.menuNm.replaceAll('\n', '<br>')"> </span>
        </a-tooltip>
      </h2>
      <div class="header-meta">
        <div class="meta-item inline-flex mr-2" v-if="getAreaName">
          <i class="icon icon-bor-pin pt-1 pr-2" />
          <span>
            {{ areaNmDtl }}
          </span>
        </div>
        <button class="c-btn btn-white btn-sm" @click="gotoMap" v-if="hasCoordinates">
          <span class="sm:hidden block">地図を見る</span>
          <span class="sm:block hidden">地図</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import Share from '../components/Share'

export default {
  name: 'PlanDetailHeader',
  components: {
    Share
  },
  props: ['value'],
  data() {
    return {
      idFavorite: '',
      showPopup: false,
      inWishList: false,
      menuBasicInfo: null,
      planIcons: null,
      areaNmDtl: ''
    }
  },
  created() {
    if (this.value) {
      this.menuBasicInfo = this.value
      this.setData()
    }
  },
  mounted() {
  },
  watch: {
    value(val) {
      this.menuBasicInfo = val
      this.setData()
      this.areaNmDtl = this.getArea
    }
  },
  methods: {
    setData() {
      if (this.menuBasicInfo) {
        this.planIcons = this.menuBasicInfo.planIcons
      }
    },
    gotoMap() {
      const { latitude, longitude } = _.get(this.menuBasicInfo, 'areaInfomation', {})
      if (latitude && longitude) {
        window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
      }
    },
    copyContent() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('Copied')
    },
    copyError() {
      this.$toasted.error('Copy failed')
    }
  },
  computed: {
    hasCoordinates() {
      return _.get(this.menuBasicInfo, 'areaInfomation.latitude', null) && _.get(this.menuBasicInfo, 'areaInfomation.longitude', null)
    },
    getAreaName() {
      // areaMidClassNm > areaDtlClassNm
      if (this.menuBasicInfo && this.menuBasicInfo.areaInfomation) {
        const areaMidClassNm = _.get(this.menuBasicInfo, 'areaInfomation.areaMidClassNm', '')
        const areaDtlClassNm = _.get(this.menuBasicInfo, 'areaInfomation.areaDtlClassNm', '')
        return [areaMidClassNm, areaDtlClassNm].filter(Boolean).join('・')
      }
      return ''
    },
    getArea() {
      const areaMidClassNm = _.get(this.menuBasicInfo, 'areaInfomation.areaMidClassNm', '')
      const areaSmlClassNm = _.get(this.menuBasicInfo, 'areaInfomation.areaSmlClassNm', '')
      const areaDtlClassNm = _.get(this.menuBasicInfo, 'areaInfomation.areaDtlClassNm', '')
      return [areaMidClassNm, areaSmlClassNm, areaDtlClassNm].filter(Boolean).join('・')
    },
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    },
    categoryTag() {
      const catLrgClassNm = _.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm', '')
      const catMidClassNm = _.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')
      const catSmlClassNm = _.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')
      return [catLrgClassNm, catMidClassNm, catSmlClassNm].filter(Boolean).join('・')
    },
    router() {
      return this.$route.fullPath
    }

  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
